export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Detalhes do Rollover',
    all: 'Todos',
    allStats: 'Todos os status',
    select: 'Selecionar',
    rolloverType: 'Tipo de rollover',
    amount: 'Valor',
    source: 'Origem',
    wallet: 'Carteira',
    current: 'Atual',
    wagered: 'Apostado',
    required: 'Exigido',
    progress: 'Progresso',
    loading: 'Carregando...',
    noData: 'Sem dados',
    noMoreData: 'Sem mais dados',
    state: 'Estado',
    type: 'Tipo',
    createdOn: 'Criado em',
    wageringRequirement: 'Requisito de aposta',
    currency: 'Moeda',
    wagerRequired: 'Aposta exigida',
    wagerCompleted: 'Aposta concluída',
    cash: 'Dinheiro',
    bonus: 'Bônus',
  },
};
